
import CardActions from '@material-ui/core/CardActions';
import React from 'react';
import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  DisabledInput,
  Edit,
  EditButton,
  Filter,
  List,
  ListButton,
  LongTextInput,
  ReferenceField,
  ReferenceInput,
  Responsive,
  SaveButton,
  SelectInput,
  SimpleForm,
  SimpleList,
  TextField,
  TextInput,
  Toolbar,
} from 'react-admin';

export const AirportFilter = props => (
  <Filter {...props}>
    <ReferenceInput label="Market" source="market_id" reference="markets">
      <SelectInput optionText="name" />
    </ReferenceInput>
    <TextInput label="Name" source="name" />
    <TextInput label="Code" source="code" />
    <BooleanInput label="Active" source="active" />
  </Filter>
);

export const AirportList = props => (
  <List {...props} bulkActionButtons={false} filters={<AirportFilter />}>
    <Responsive
      small={<SimpleList primaryText={record => `${record.name}`} />}
      medium={
        <Datagrid>
          <EditButton />
          <TextField source="id" />
          <TextField source="name" />
          <TextField source="code" />
          <ReferenceField label="Market" source="market_id" reference="markets">
            <TextField source="short_name" />
          </ReferenceField>
          <BooleanField source="active" />
        </Datagrid>
      }
    />
  </List>
);

export const AirportCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput
        label="Market"
        source="market_id"
        reference="markets"
        allowEmpty
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <LongTextInput source="name" />
      <LongTextInput source="code" />
      <BooleanInput source="active" />
    </SimpleForm>
  </Create>
);

const PostEditToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export const AirportEdit = props => (
  <Edit title={<AirportTitle />} actions={<AirportActions />} {...props}>
    <SimpleForm toolbar={<PostEditToolbar />}>
      <DisabledInput source="id" />
      <ReferenceInput
        label="Market"
        source="market_id"
        reference="markets"
        allowEmpty
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <LongTextInput source="name" />
      <LongTextInput source="code" />
      <BooleanInput source="active" />
    </SimpleForm>
  </Edit>
);

const AirportTitle = ({ record }) => {
  return <span>{record ? `"${record.name}"` : ''}</span>;
};

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

const AirportActions = ({ basePath, data }) => (
  <CardActions style={cardActionStyle}>
    <ListButton basePath={basePath} />
  </CardActions>
);



// WEBPACK FOOTER //
// ./src/airports.js